import { AppIdentifier } from '@/interfaces/accounts';
import '@/styles/icons.scss';

export default function Svg() {
  return (
    <svg version="1.1" id="umbrella_icons" x="0px" y="0px" style={{ position: 'absolute', width: 0, height: 0, visibility: 'hidden' }} viewBox="0 0 175 175">
      <linearGradient id="gradient" data-name="Gradient blue-to-green" x1="9.04" y1="87.36" x2="166.33" y2="87.36" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#09f287" />
        <stop offset="0.18" stopColor="#06dfa8" />
        <stop offset="0.38" stopColor="#03cfc2" />
        <stop offset="0.58" stopColor="#01c4d5" />
        <stop offset="0.78" stopColor="#00bde0" />
        <stop offset="1" stopColor="#00bbe4" />
      </linearGradient>

      <defs>
        <defs>
          <symbol id="link_logo" viewBox="0 0 155.91 23.81">
            <title>Link Mobility Logo</title>
            <path
              className="cls-1"
              d="M91.08,60.34A5.31,5.31,0,0,0,89.57,60a8.74,8.74,0,0,0-1.83.07,10.55,10.55,0,0,0-1.86.43,9.61,9.61,0,0,0-1.63.7,6.62,6.62,0,0,0-1.29.91,3.35,3.35,0,0,0-.8,1.07A1.56,1.56,0,0,0,82,64.26a1.6,1.6,0,0,0,.64.87,3.59,3.59,0,0,0,1.38.56,6.77,6.77,0,0,0,1.36.13l.68,0a10.31,10.31,0,0,0,2.29-.44,9.45,9.45,0,0,0,2-.89,5.65,5.65,0,0,0,1.42-1.15,2.34,2.34,0,0,0,.6-1.23,1.38,1.38,0,0,0-.32-1A2.46,2.46,0,0,0,91.08,60.34Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M89.62,69.31a5.77,5.77,0,0,0-1.91-.84,8.09,8.09,0,0,0-2.32-.21A11.59,11.59,0,0,1,81.87,68a5.28,5.28,0,0,1-2.19-1.1,2.53,2.53,0,0,1-.86-1.55,3,3,0,0,1,.39-1.77,1.5,1.5,0,0,0,.21-1,1,1,0,0,0-.44-.66,2.15,2.15,0,0,0-.94-.33,5.09,5.09,0,0,0-1.34,0,8.28,8.28,0,0,0-1.51.36,9.89,9.89,0,0,0-1.45.62,8.71,8.71,0,0,0-1.29.82,5.48,5.48,0,0,0-1,1,2.37,2.37,0,0,0-.48,1,1,1,0,0,0,.14.79,1.4,1.4,0,0,0,.78.52,3.41,3.41,0,0,0,1,.13l.41,0a7.24,7.24,0,0,1,2.52.21,3.9,3.9,0,0,1,1.81,1,3.2,3.2,0,0,1,.84,1.92,5.67,5.67,0,0,1-.55,2.82,4.17,4.17,0,0,0-.38,1.93,3.5,3.5,0,0,0,.61,1.79,4.35,4.35,0,0,0,1.63,1.4,6.74,6.74,0,0,0,2.63.69,9.3,9.3,0,0,0,3.12-.33A9.84,9.84,0,0,0,88.37,77a7.64,7.64,0,0,0,2-1.94,4.87,4.87,0,0,0,.88-2.24,3.53,3.53,0,0,0-.36-2A4,4,0,0,0,89.62,69.31Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M74.15,69.45a2.69,2.69,0,0,0-1.32-.53,5.31,5.31,0,0,0-1.72.06,8.65,8.65,0,0,0-1.95.62,10.92,10.92,0,0,0-1.87,1.07A10.33,10.33,0,0,0,65.76,72a7.7,7.7,0,0,0-1.11,1.48A4.27,4.27,0,0,0,64.11,75a2.19,2.19,0,0,0,.21,1.32,2,2,0,0,0,1,.86,3.73,3.73,0,0,0,1.66.27,6.68,6.68,0,0,0,1.5-.24c.23-.06.48-.14.72-.23a10.5,10.5,0,0,0,2.33-1.21,10.16,10.16,0,0,0,1.89-1.66,6.68,6.68,0,0,0,1.17-1.81,3.14,3.14,0,0,0,.26-1.67A1.84,1.84,0,0,0,74.15,69.45Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M99.95,74.93V61.47H97.52v13.6a3.07,3.07,0,0,0,3.31,3.33h1.5V76.33h-1.07C100.28,76.33,99.95,75.86,99.95,74.93Z"
              transform="translate(-64.09 -60)"
            />
            <rect className="cls-1" x="40.99" y="1.4" width="2.57" height="2.57" />
            <rect className="cls-1" x="41.06" y="6.34" width="2.42" height="12.05" />
            <path
              className="cls-1"
              d="M116.85,66.2a4.31,4.31,0,0,0-3.21,1.36V66.34h-2.38V78.4h2.42V71.05a2.4,2.4,0,0,1,2.5-2.69c1.35,0,2.42.81,2.42,2.69V78.4H121V70.7a4.43,4.43,0,0,0-1.21-3.4A4.18,4.18,0,0,0,116.85,66.2Z"
              transform="translate(-64.09 -60)"
            />
            <polygon
              className="cls-1"
              points="70.74 6.34 67.79 6.34 63.1 11.91 63.1 1.47 60.68 1.47 60.68 18.4 63.1 18.4 63.1 14.86 64.89 12.84 68.26 18.4 71.26 18.4 66.55 11.08 70.74 6.34"
            />
            <path
              className="cls-1"
              d="M155.1,66.28A4.6,4.6,0,0,0,151,68.47a4.06,4.06,0,0,0-3.85-2.19,4.53,4.53,0,0,0-3.55,1.56V66.43h-1.27v12h1.27V71c0-2.26,1.24-3.58,3.38-3.58s3.3,1.27,3.3,3.58V78.4h1.27V70.75A3.15,3.15,0,0,1,155,67.4c2.13,0,3.3,1.27,3.3,3.58V78.4h1.24V70.75a4.5,4.5,0,0,0-1.24-3.33A4.45,4.45,0,0,0,155.1,66.28Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M167.47,66.28a4.59,4.59,0,0,0-3.33,1.32,6.57,6.57,0,0,0-1.49,4.82,6.56,6.56,0,0,0,1.49,4.82,4.86,4.86,0,0,0,6.65,0,6.56,6.56,0,0,0,1.49-4.82,6.56,6.56,0,0,0-1.49-4.82A4.59,4.59,0,0,0,167.47,66.28Zm2.48,10.13a3.54,3.54,0,0,1-5,0c-1-1-1.07-2.61-1.07-4s.07-3,1.07-4a3.54,3.54,0,0,1,5,0c1,1,1.07,2.61,1.07,4S170.94,75.42,169.95,76.41Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M180.4,66.28A4,4,0,0,0,176.85,68V60.72h-1.27V78.4h1.27V76.86a4,4,0,0,0,3.55,1.69,4.18,4.18,0,0,0,2.93-1c1.22-1.22,1.54-3.2,1.54-5.09s-.32-3.87-1.54-5.09A4.18,4.18,0,0,0,180.4,66.28Zm-.17,11.15c-2.93,0-3.38-2.53-3.38-5s.45-5,3.38-5,3.38,2.53,3.38,5S183.16,77.43,180.23,77.43Z"
              transform="translate(-64.09 -60)"
            />
            <rect className="cls-1" x="123.91" y="0.72" width="1.56" height="1.56" />
            <rect className="cls-1" x="124.05" y="6.43" width="1.27" height="11.97" />
            <path
              className="cls-1"
              d="M194.6,75.27V60.72h-1.27V75.3c0,1.86.94,3.1,2.88,3.1h1.09V77.28h-.87C195,77.28,194.6,76.61,194.6,75.27Z"
              transform="translate(-64.09 -60)"
            />
            <rect className="cls-1" x="135.45" y="0.72" width="1.56" height="1.56" />
            <rect className="cls-1" x="135.6" y="6.43" width="1.27" height="11.97" />
            <path
              className="cls-1"
              d="M206.52,62.61h-1.27v3.82h-1.64v.94h1.64v7.89c0,1.81,1,3.13,2.88,3.13h1.09V77.28h-.87c-1.27,0-1.84-.75-1.84-2V67.38h2.71v-.94h-2.71Z"
              transform="translate(-64.09 -60)"
            />
            <path
              className="cls-1"
              d="M218.61,66.43,215,76.91l-3.6-10.48H210l4.37,12-1,2.66c-.45,1.19-.82,1.64-2.19,1.64h-.47v1.12h.6a3.26,3.26,0,0,0,2.26-.77,3.1,3.1,0,0,0,.82-1.39L220,66.43Z"
              transform="translate(-64.09 -60)"
            />
          </symbol>
        </defs>
        <defs>
          <rect id="lm_rect" x="3.63" y="3.27" width="169.26" height="169.26" rx="12.08" ry="12.08" />
        </defs>

        <g id="lm_blob" className="cls-2">
          <path
            className="cls-3"
            d="M57.53,3.27a6.08,6.08,0,0,0,.24,1.27,9.14,9.14,0,0,0,3.68,4.95,20.47,20.47,0,0,0,7.86,3.18,38.64,38.64,0,0,0,7.75.73q1.86,0,3.87-.16A58.83,58.83,0,0,0,94,10.71a53.94,53.94,0,0,0,11.49-5,39.8,39.8,0,0,0,3.57-2.39H57.53Z"
          />
          <path
            className="cls-3"
            d="M3.64,65.42a54.74,54.74,0,0,0,4.72-4.75A38.13,38.13,0,0,0,15,50.33a17.94,17.94,0,0,0,1.42-9.52,10.48,10.48,0,0,0-3.78-6.68,15.34,15.34,0,0,0-7.52-3Q4.38,31,3.57,30.92v34.5H3.64Z"
          />
          <path
            className="cls-3"
            d="M3.63,18.82V15.35A12.13,12.13,0,0,1,15.71,3.27H40.29a15.37,15.37,0,0,0-.88,7.11,14.44,14.44,0,0,0,4.9,8.86A30.1,30.1,0,0,0,56.82,25.5,66.1,66.1,0,0,0,76.89,27.3,46.19,46.19,0,0,1,90.1,28.48,32.94,32.94,0,0,1,101,33.29a22.75,22.75,0,0,1,7.41,8.26,20.16,20.16,0,0,1,2,11.5,27.76,27.76,0,0,1-5,12.79A43.61,43.61,0,0,1,93.87,76.94a56.11,56.11,0,0,1-16.11,7.32,53.07,53.07,0,0,1-17.86,1.9,38.38,38.38,0,0,1-15-4,24.79,24.79,0,0,1-9.33-8A19.9,19.9,0,0,1,32.07,64a23.8,23.8,0,0,1,2.18-11A32.36,32.36,0,0,0,37.4,36.91,18.27,18.27,0,0,0,32.58,26a22.25,22.25,0,0,0-10.32-6A41.23,41.23,0,0,0,7.88,18.82c-0.81,0-1.61.1-2.35,0.1a17.08,17.08,0,0,1-2-.07h0Z"
          />
        </g>

        <g id="logo_path" data-name="logo">
          <path
            className="logo"
            d="M58.59,151.32c9-32,20.54-66.1,33.79-101.65m0,0S42.7,66.61,10.59,111.08m48.75,40.8A190.89,190.89,0,0,0,9.79,110.37M127.3,150a379.1,379.1,0,0,0-69.36,1.37m68.59-1.42C119.64,99.61,108,74.11,92.38,49.67m0,0C59.27,42.76,31,43.54,11.65,58.5m-1.07,53.27,1-54m80.79-8.06c-7.68-8.71-20.74-26.09-35.2-26M11,59,57.6,23.34m48.46,0q-4.64,1.85-13.68,26.29m-35.74-26,49.93-.29m44.31,34c-6.35-10.59-28.63-18.82-58.5-7.68m53.24,2C130.13,39,124,35.17,105.69,23.12M164.64,107Q140.43,64.41,92.38,49.67M126,150.49l39.2-44.1M150.71,57l14.16,50.89"
            transform="translate(1.9 2.85)"
          />
        </g>

        <symbol id="umbrella_logo_rect_bg" viewBox="0 0 175 175">
          <title>Umbrella logo</title>
          <use href="#lm_rect" fill="#1d153e" />
          <use href="#logo_path" strokeWidth="6px" stroke="url(#gradient)" />
        </symbol>

        <symbol id="umbrella_logo_login" viewBox="0 0 175 175">
          <title>Umbrella logo</title>
          <use href="#logo_path" strokeWidth="6px" stroke="#ffffff" />
        </symbol>

        <symbol id="umbrella_logo_watermark" viewBox="0 0 175 175">
          <title>Umbrella</title>
          <use href="#logo_path" strokeWidth="6px" />
        </symbol>

        <symbol id="umbrella_logo_menu" viewBox="0 0 175 175">
          <title>Umbrella</title>
          <use href="#logo_path" strokeWidth="6px" stroke="url(#gradient)" />
        </symbol>

        <symbol id="rf_icon" viewBox="0 0 175 175">
          <title>Umbrella portal</title>
          <use href="#lm_rect" fill="#0093B9" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(19.04 124.38)">
            Um
          </text>
        </symbol>

        <symbol id="sms_inbox_icon" viewBox="0 0 175 175">
          <title>SMS inbox</title>
          <use href="#lm_rect" fill="#AD1457" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(47.25 124.01)">
            In
          </text>
        </symbol>

        <symbol id="subscription_icon" viewBox="0 0 175 175">
          <title>Subscription</title>
          <use href="#lm_rect" fill="#1565C0" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(34.32 124.85)">
            Su
          </text>
        </symbol>

        <symbol id="permission_icon" viewBox="0 0 175 175">
          <title>Permission</title>
          <use href="#lm_rect" fill="#f9a825" />
          <use href="#lm_blob" />
          <text className="cls-11" transform="translate(36.48 124.32)">
            P
          </text>
          <text className="cls-4" transform="translate(92.21 124.32)">
            e
          </text>
        </symbol>

        <symbol id="push_icon" viewBox="0 0 175 175">
          <title>Push</title>
          <use href="#lm_rect" fill="#00695c" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(33.95 124.11)">
            P
          </text>
          <text className="cls-4" transform="translate(90.67 124.11)">
            u
          </text>
        </symbol>

        <symbol id="sms_tracking_icon" viewBox="0 0 175 175">
          <title>LINKTrack</title>
          <use href="#lm_rect" fill="#00838f" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(42.96 124.54)">
            Tr
          </text>
        </symbol>

        <symbol id="voucher_icon" viewBox="0 0 175 175">
          <title>Voucher</title>
          <use href="#lm_rect" fill="#6a1b9a" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(30.96 124.54)">
            Vo
          </text>
        </symbol>

        <symbol id="webhook_icon" viewBox="0 0 175 175">
          <title>Webhook</title>
          <use href="#lm_rect" fill="#D12C9F" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(17.96 124.54)">
            Wh
          </text>
        </symbol>

        <symbol id="sms_events_icon" viewBox="0 0 175 175">
          <title>SMS Event</title>
          <use href="#lm_rect" fill="#32B27E" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(34.31 125.07)">
            Ev
          </text>
        </symbol>

        <symbol id="bruger_icon" viewBox="0 0 175 175">
          <title>Brugerindsamling</title>
          <use href="#lm_rect" fill="#283593" />
          <use href="#lm_blob" />
          <text className="cls-4" transform="translate(38.31 125.07)">
            Br
          </text>
        </symbol>

        <symbol id="default_icon" viewBox="0 0 175 175">
          <title>Default</title>
          <use href="#lm_rect" fill="#878787" />
          <use href="#lm_blob" />
        </symbol>
      </defs>
    </svg>
  );
}

export const iconMap: Record<AppIdentifier, IconName> = {
  PORTAL: '#umbrella_logo_menu',
  SMSINBOX: '#sms_inbox_icon',
  PUSH: '#push_icon',
  PERMISSION: '#permission_icon',
  SUBSCRIPTION: '#subscription_icon',
  WEBHOOK: '#webhook_icon',
  LINKTRACK: '#sms_tracking_icon',
  VOUCHER: '#voucher_icon',
  SMSEVENTS: '#sms_events_icon',
};

export type IconName =
  | '#link_logo'
  | '#umbrella_logo_menu'
  | '#umbrella_logo_rect_bg'
  | '#sms_inbox_icon'
  | '#subscription_icon'
  | '#permission_icon'
  | '#push_icon'
  | '#sms_tracking_icon'
  | '#voucher_icon'
  | '#webhook_icon'
  | '#sms_events_icon'
  | '#bruger_icon'
  | '#default_icon'
  | '#rf_icon'
  | '#umbrella_logo_login'
  | '#umbrella_logo_watermark';

export function Icon({
  name,
  size = 24,
  width,
  height,
  title,
  viewBox,
}: {
  name: IconName;
  size?: number;
  width?: number;
  height?: number;
  title?: string;
  viewBox?: string;
}) {
  return (
    <svg
      width={width ?? size}
      height={height ?? size}
      viewBox={viewBox ?? '0 0 175 175'}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <use href={`${name}`} />
    </svg>
  );
}
